import { errorHandler } from "@/services/toastHandler";

const systemAcceptBetsModule = {
  namespaced: true,
  state: {
    loading: false,
    saving: false,
  },
  mutations: {
    LOADING: (s, data) => (s.loading = data),
    SAVING: (s, data) => (s.saving = data),
  },
  actions: {
    async getSystemAcceptBets({ commit }) {
      commit("LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/settings/detail", {
          params: { section: "system", key: "system-accept-bets" },
        });
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOADING", false);
      }
    },
    async updateSystemAcceptBets({ commit }, { acceptBets, turnOnAt, password }) {
      commit("SAVING", true);
      try {
        const res = await this.$api.post("/v1/portal/settings/update", {
          section: "system",
          key: "system-accept-bets",
          value: { acceptBets, turnOnAt },
          password,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SAVING", false);
      }
    },
  },
};

export default systemAcceptBetsModule;
